import { transport } from '/api/core';
import { buzzerAppNotifications } from '/common/buzzer/buzzerAppNotifications';

import { initListeners as initAuthListeners } from './toolkits/auth/listeners';
import { initListeners as initAppListeners } from './toolkits/app/listeners';
import { initListeners as initSpaceListeners } from './toolkits/space/listeners';
import { initListeners as initUIListeners } from './toolkits/ui/listeners';
import { logout } from './toolkits/auth/actions';
import { systemRehydrate } from './systemActions';
import { store } from './store';

export const setupAppInterceptors = () => {
  transport.onFailureEx = ({ code }) => {
    if (code === 401) {
      store.dispatch(logout());
    }
  };
};

export const initAppStore = () => {
  store.dispatch(systemRehydrate());
};
export const initServices = () => {
  buzzerAppNotifications.init(store);
};
export const initAllListeners = () => {
  initAuthListeners();
  initAppListeners();
  initSpaceListeners();
  initUIListeners();
};

export const initApp = () => {
  initAllListeners();

  setupAppInterceptors();
  initServices();

  initAppStore();
};
